import { Tween, TweenMax } from 'gsap';
import SoundManager from '../Sound/SoundManager';
import { Pausable } from '../Utils/Pausable';
import Core from '../Core/Core';
import getLogger, { ILogger } from '../Core/Logger';

const logger: ILogger = getLogger('[FOCUS MANAGER]:');

export class FocusManager {
    private static instanceCache: FocusManager;

    static get instance(): FocusManager {
        if (!this.instanceCache) {
            this.instanceCache = new FocusManager();
        }
        return this.instanceCache;
    }

    public get hasFocus() {
        return this.focused;
    }

    public tweensToResume: Tween[] = [];

    private focused: boolean = true;
    private listeners: Array<(focus: boolean) => void> = [];

    public unFocus() {
        if (!this.focused) {
            return;
        }
        this.focused = false;
        SoundManager.stopAllAudio();
        TweenMax.getAllTweens(true).forEach(x => {
            if (!x.paused()) {
                this.tweensToResume.push(x);
            }
            x.pause();
        });
        // TweenMax.pauseAll(true, true, true);
        Pausable.setPaused(true);
        this.emit(this.focused);
    }

    public focus() {
        if (this.focused || Core.sdk.adPlaying) {
            return;
        }
        this.focused = true;

        SoundManager.resumeAllAudio();
        this.tweensToResume.forEach(x => {
            try {
                x.resume();
            } catch (e) {
                logger.warn('Could not resume tween.');
            }
        });
        this.tweensToResume = [];
        // TweenMax.resumeAll(true, true, true);
        Pausable.setPaused(Core.store ? Core.store.getState().StatePause.paused : false);
        this.emit(this.focused);
    }

    public addListener(callback: (focus: boolean) => void) {
        this.listeners.push(callback);
    }

    public removeListener(callback: (focus: boolean) => void) {
        this.listeners.splice(this.listeners.indexOf(callback));
    }

    private emit(focus: boolean) {
        this.listeners.forEach(listener => listener(focus));
    }
}
